import './ContactProfileController.scss';
import {Contact, ContactType} from "../../model/Contact";
import {IController, IScope} from "angular";
import {ContactProfileTab} from "../../model/ContactProfileTab";

type TabsMap = { [key in ContactProfileTab]: boolean }

const TAB_INDEX_MAP = {
    'opportunity_tab': ContactProfileTab.OPPORTUNITIES,
    'mailing_address': ContactProfileTab.MAILING_ADDRESS,
    'date_fields': ContactProfileTab.DATE_FIELDS,
    'loan': ContactProfileTab.LOAN,
    'property': ContactProfileTab.PROPERTY,
    'marketing': ContactProfileTab.MARKETING,
    'financials': ContactProfileTab.FINANCIALS,
    'co_borrowers': ContactProfileTab.CO_BORROWERS,
    'application': ContactProfileTab.APPLICATION,
    'opportunity_log': ContactProfileTab.OPPORTUNITY_LOG,
    'campaign_log': ContactProfileTab.CAMPAIGN_LOG
};

export interface ContactProfileControllerScope<T extends Contact> extends IScope {
    selectedId: number;
    restoreCustomer: () => void;
    selectedContact: T;
    selectedTabIndex: number;
    tabs: TabsMap
}

export abstract class ContactProfileController<T extends Contact, S extends ContactProfileControllerScope<T>>
    implements IController {

    static template = require("./ContactProfileController.html");

    constructor(protected $scope: S,
                protected $routeParams: ng.route.IRouteParamsService,
                protected selectedContact: T) {
        let tabs = this.tabs();
        $scope.tabs = this.initTabs(tabs);
        $scope.selectedTabIndex = this.initSelectedTabIndex(tabs);
        $scope.selectedContact = selectedContact;
        $scope.selectedContact.type = this.contactType();
    }

    private initSelectedTabIndex(tabs: ContactProfileTab[]): number {
        let selectedTab = TAB_INDEX_MAP[this.$routeParams.selectedTab];
        let selectedTabIndex = tabs.indexOf(selectedTab);
        return selectedTabIndex > 0? selectedTabIndex : 0;
    }

    private initTabs(tabs: ContactProfileTab[]): TabsMap {
        let allowedTabs = tabs as string[];
        let map = {} as TabsMap;
        for (let key in ContactProfileTab) {
            map[key] = allowedTabs.includes(key);
        }
        return map;
    }

    protected abstract tabs(): ContactProfileTab[];


    protected abstract contactType(): ContactType;
}

